<ng-container [ngSwitch]="tyreType?.id || tyreDefaults[0]?.tyre_type?.id">
  <wchfs-icon *ngSwitchCase="TyreType.CAR" svgIcon="pso:tyre_type_car_l" size="40"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="TyreType.SUV_4X4" svgIcon="pso:tyre_type_suv_4x4_l" size="40"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="TyreType.VAN" svgIcon="pso:tyre_type_van_l" size="40"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="TyreType.TRUCK" svgIcon="pso:tyre_type_truck_l" size="40"></wchfs-icon>
  <wchfs-icon *ngSwitchCase="TyreType.INDUSTRIAL" svgIcon="pso:tyre_type_industrial_l" size="40"></wchfs-icon>
</ng-container>
